/**
 * Slug helpers.
 *
 * A deliberate mirror of `infra/lambda/backend/services/AssetKeys.ts`. They are
 * separate npm packages and cannot share a module, so the duplication is real -
 * the form proposes a slug, and the server is what should ultimately guarantee
 * uniqueness. If they ever disagree, the server wins.
 */

export function slugify(title: string): string {
  return title
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    // Apostrophes vanish rather than becoming hyphens: "Saria's Song" must not
    // slug to "saria-s-song".
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** A collision takes `-2`, because the first one keeps the bare slug. */
export function uniqueSlug(base: string, taken: Iterable<string>): string {
  if (!base) return "";
  const used = new Set(taken);
  if (!used.has(base)) return base;
  let n = 2;
  while (used.has(`${base}-${n}`)) n++;
  return `${base}-${n}`;
}
